export function visibleRaffleSubmissionIds({
  status,
  remainingSubmissionIds,
  winnerSubmissionIds,
  allSubmissionIds,
}: {
  status?: string | null;
  remainingSubmissionIds?: string[] | null;
  winnerSubmissionIds?: readonly string[] | null;
  allSubmissionIds: string[];
}): string[] {
  // DRAWING holds original seats (empty cells) so the grid never reflows.
  // COMPLETED drops non-winners entirely so Stage matches the end of DRAWING.
  if (status === 'COMPLETED') {
    const winners = (winnerSubmissionIds ?? []).filter((id) => id.length > 0);
    const winnerSet = new Set(
      winners.length > 0 ? winners : (remainingSubmissionIds ?? []),
    );
    return allSubmissionIds.filter((id) => winnerSet.has(id));
  }
  void remainingSubmissionIds;
  return allSubmissionIds;
}

export function isRaffleTicketStillIn({
  status,
  remainingSubmissionIds,
  submissionId,
}: {
  status?: string | null;
  remainingSubmissionIds?: string[] | null;
  submissionId: string;
}): boolean {
  if (status !== 'DRAWING' && status !== 'COMPLETED') {
    return true;
  }
  return (remainingSubmissionIds ?? []).includes(submissionId);
}
